import React from 'react';

const CarrierName =
  (handleClick) =>
  ({ rowData }) => {
    const { carrier } = rowData;
    const { name, id } = carrier;
    return carrier && typeof carrier === 'object' ? (
      <div onClick={handleClick(id)}>
        <b>{name}</b>
      </div>
    ) : null;
  };

export default CarrierName;
